import svg from 'src/images/custom-icons/financials.icon.svg';

const financialsSideBarTokens = {
    iconData: svg,
    iconWidth: 20,
    iconHeight: 20,
    iconTitle: 'Financials'
};

export default financialsSideBarTokens;
